import _isEmpty from 'lodash/isEmpty';

export function getGroupOptions(groups) {
  return groups.map((group) => ({
    key: group.id,
    text: group.name,
    value: group.id,
  }));
}

export function getSelectedQuestions(questions, selectedIds) {
  return questions.filter((question) => selectedIds.includes(question.id));
}

export function calculateBulkOperationResult(selectedQuestions, operation, value) {
  if (_isEmpty(selectedQuestions)) {
    return {
      success: false,
      message: 'No questions selected',
    };
  }

  const count = selectedQuestions.length;

  switch (operation) {
    case 'activate':
      return {
        success: true,
        message: `${count} question${count > 1 ? 's' : ''} activated successfully`,
      };

    case 'archive':
      return {
        success: true,
        message: `${count} question${count > 1 ? 's' : ''} archived successfully`,
      };

    case 'delete':
      return {
        success: true,
        message: `${count} question${count > 1 ? 's' : ''} deleted successfully`,
      };

    case 'assign_groups':
      if (!value || _isEmpty(value)) {
        return {
          success: false,
          message: 'Please select at least one group',
        };
      }
      return {
        success: true,
        message: `${count} question${count > 1 ? 's' : ''} assigned to groups successfully`,
      };

    default:
      return {
        success: false,
        message: 'Invalid operation',
      };
  }
}

export function validateQuestionData(questionData) {
  const errors = {};
  const { text = '', answers = [] } = questionData || {};

  if (!text || text.trim().length < 5) {
    errors.text = 'Question must be at least 5 characters long';
  }

  if (text && text.length > 500) {
    errors.text = 'Question must be less than 500 characters';
  }

  if (!answers || answers.length === 0) {
    errors.answers = 'At least one answer is required';
  } else {
    const answerErrors = [];
    let hasPreferredAnswer = false;

    answers.forEach((answer, index) => {
      const answerError = {};

      if (!answer.text || answer.text.trim().length === 0) {
        answerError.text = 'Answer text is required';
      }

      if (answer.text && answer.text.length > 1000) {
        answerError.text = 'Answer must be less than 1000 characters';
      }

      if (answer.isPreferred) {
        hasPreferredAnswer = true;
      }

      answerErrors[index] = answerError;
    });

    if (!hasPreferredAnswer && answers.length > 1) {
      errors.preferredAnswer = 'Please select a preferred answer';
    }

    if (answerErrors.some((error) => !_isEmpty(error))) {
      errors.answerErrors = answerErrors;
    }
  }

  return {
    isValid: _isEmpty(errors),
    errors,
  };
}

export function createNewAnswer(questionId, text = '', isPreferred = false) {
  return {
    text,
    isPreferred,
    question: questionId,
  };
}
